var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreventCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#618EF7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,42.1l-13.3,9.3c-0.4,0.3-0.9-0.1-0.8-0.6l4.7-15.5L7.7,25.5c-0.4-0.3-0.2-0.9,0.3-0.9l16.2-0.3l5.3-15.3 c0.2-0.5,0.8-0.5,1,0l5.3,15.3L52,24.5c0.5,0,0.7,0.6,0.3,0.9l-12.9,9.8l4.7,15.5c0.1,0.5-0.4,0.9-0.8,0.6L30,42.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreventCustom);
export default __webpack_public_path__ + "static/media/PreventCustom.c2c45175d795d97af68e2e34bf45fd6d.svg";
export { ForwardRef as ReactComponent };